import { storedLocalApiPort } from "./localApi";
/**
 * Re-afirma el usuario activo en la EXTENSIÓN local (server de la app de
 * escritorio) haciendo POST /api/session/account. Ese endpoint setea
 * `currentUserId` en la extensión, que scopea los snapshots per-user de cada
 * workspace (db/users/<userId>/workspace_snapshots/). Si `currentUserId` queda
 * en null, GET /api/workspaces/snapshot responde 204 → el renderer cae al
 * template base sin `userType` → re-muestra la pantalla Welcome aunque el
 * workspace ya haya sido configurado.
 *
 * Helper compartido para el sync que originalmente estaba duplicado inline en
 * varios carriles de login (Root, deep-link, login form). Es idempotente y
 * no-op en browser / sin sesión: solo dispara cuando hay puerto de API local +
 * userId en localStorage (contexto Electron). El `accessKey` es OPCIONAL — el
 * endpoint solo requiere `account` para fijar `currentUserId` — así que se
 * envía si está pero su ausencia no bloquea el sync.
 *
 * El fetch está acotado por timeout: nunca debe colgar al llamador (p. ej. el
 * bootstrap de auth), aunque el agente local esté lento o caído.
 */
const SYNC_TIMEOUT_MS = 4000;

export async function syncSessionWithExtension(): Promise<void> {
  const port = storedLocalApiPort();
  const userId = localStorage.getItem("@Eriol/system/userId");
  const accessKey = localStorage.getItem("@Eriol/system/accessKey");

  if (!port || !userId) return;

  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), SYNC_TIMEOUT_MS);

  try {
    await fetch(`http://localhost:${port}/api/session/account`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(
        accessKey ? { account: userId, accessKey } : { account: userId },
      ),
      signal: controller.signal,
    });
  } catch (err) {
    // Timeout (abort) o agente inalcanzable: no es fatal — el sync se
    // reintenta en el próximo bootstrap/auth-changed.
    console.warn("Could not sync session with extension:", err);
  } finally {
    clearTimeout(timeout);
  }
}
